import omit from 'lodash/fp/omit';
import type { UserProfile } from 'oidc-client-ts';

import type { RioProfile } from './loginSlice';

const stripSnakeProps = omit(['family_name', 'given_name']);

export const mapUserProfile = (profile: UserProfile): RioProfile => ({
    sub: profile.sub,
    azp: profile.azp,
    givenName: profile.given_name,
    familyName: profile.family_name,
    name: profile.name,
    locale: profile.locale,
    email: profile.email,
    ...stripSnakeProps(profile),
});
